import { FC } from 'react';
import { WarningCircleIcon } from '@phosphor-icons/react';
import styles from './PlanLimitReachedModal.module.scss';

interface Props {
  open: boolean;
  onClose: () => void;
  planName: string;
  currentCount: number;
  maxAthletes: number;
}

export const PlanLimitReachedModal: FC<Props> = ({ open, onClose, planName, currentCount, maxAthletes }) => {
  if (!open) return null;
  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.icon}><WarningCircleIcon size={32} weight="fill" /></div>
        <h2 className={styles.title}>Limite atleti raggiunto</h2>
        <p className={styles.body}>
          Il tuo piano <strong>{planName}</strong> consente fino a <strong>{maxAthletes}</strong> atleti.
          Sei attualmente a <strong>{currentCount}</strong>. Per aggiungere nuovi atleti contatta il supporto LeoPart.
        </p>
        <div className={styles.actions}>
          <button className={styles.btnSecondary} onClick={onClose}>Chiudi</button>
          <a className={styles.btnPrimary} href="mailto:supporto@leopart.com?subject=Upgrade%20piano%20-%20Limite%20atleti">
            Contatta supporto
          </a>
        </div>
      </div>
    </div>
  );
};
